module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/cleaningcart/cleaning_cart.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/cleaningcart/cleaning_cart.png
// module id = 538
// module chunks = 0